import { GetTonePriceDetailsDto, GetTonePriceDetailsDtoImpl } from './gettonepricedetailsdto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class GetTonePriceBuilder
{
    constructor(private getTonePriceList: any)
    {
        if(getTonePriceList.responseDetails === undefined)
        {
            throw new NoDataException("Get Tone Price data doesnt exists");
        }
    }

    buildAll(): GetTonePriceDetailsDto[]
    {
        return this.parseGetTonePriceDetailsResponse();
    }
    
    private parseGetTonePriceDetailsResponse(): GetTonePriceDetailsDto[]
    {
        let listOfTonePriceDetails: GetTonePriceDetailsDto[] = [];
        
        let toneDto = null;
        this.getTonePriceList.responseDetails.forEach((toneDetailsItem: any) =>
        {
            toneDto = new GetTonePriceDetailsDtoImpl();
           
            let price  =  (toneDetailsItem.amount);
            toneDto.setPrice(Number(price).toFixed(1));
            toneDto.setLanguageId(toneDetailsItem.languageId);
            toneDto.setPackName(toneDetailsItem.packName);
            toneDto.setStatusCodes(toneDetailsItem.statusCodes);
            toneDto.setStatusDesc(toneDetailsItem.statusDesc);
            toneDto.setId(toneDetailsItem.toneId);
           
            if(toneDetailsItem.subscriberStatus === "D"  || toneDetailsItem.subscriberStatus === "NA")
            {   
                toneDto.setIsNewUser(true);
            }
            else
            {
                toneDto.setIsNewUser(false);
            }


            toneDto.setBPartyMsisdn(toneDetailsItem.bPartyMsisdn);
            
            listOfTonePriceDetails.push(toneDto);
        });
        return listOfTonePriceDetails;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricebuilder.ts